// Imports => Constants
import {ENDPOINTS} from '@constants';

export class ReportingApi {
  constructor(Client, NoBaseClient, config) {
    this.Client = Client;
    this.config = config;
  }

  report = (error) => {
    const data = {
      error_component: error.component,
      error_message: error.message,
      error_location: error.location,
      error_stack: error.stack,
    };
    return this.Client.post(`${ENDPOINTS.REPORTING.REPORT}`,  data).then(
      (response) => response.data
    );
  };
}

export default ReportingApi;
